import { and, desc, eq } from "drizzle-orm";
import { cash_movement, type PowerSyncDrizzleDB, register_session } from "@malla/powersync";
import { liveCashMovementFilters, liveRegisterSessionFilters } from "../live/filters";

export function getOpenSessionQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
) {
  return db
    .select()
    .from(register_session)
    .where(
      and(
        eq(register_session.organization_id, organizationId),
        eq(register_session.branch_id, branchId),
        eq(register_session.status, "open"),
        ...liveRegisterSessionFilters(),
      ),
    )
    .orderBy(desc(register_session.opened_at))
    .limit(1);
}

export function getSessionsQuery(db: PowerSyncDrizzleDB, organizationId: string, branchId: string) {
  return db
    .select()
    .from(register_session)
    .where(
      and(
        eq(register_session.organization_id, organizationId),
        eq(register_session.branch_id, branchId),
        ...liveRegisterSessionFilters(),
      ),
    )
    .orderBy(desc(register_session.opened_at));
}

export function getCashMovementsQuery(db: PowerSyncDrizzleDB, registerSessionId: string) {
  return db
    .select()
    .from(cash_movement)
    .where(
      and(eq(cash_movement.register_session_id, registerSessionId), ...liveCashMovementFilters()),
    )
    .orderBy(desc(cash_movement.created_at));
}
